









































import _ from 'lodash'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CompanySummaryReport } from '@/utils/Interfaces'
import BaoCaoBangTongHop from './BaoCaoBangTongHop.vue'

@Component({
  components: {
    BaoCaoBangTongHop,
  }
})
export default class TongHopDtLnTlCtDuLieuBaoCao extends Vue {
  @Prop(Boolean) readonly loading!: boolean
  @Prop(Array) readonly companySummaryReports!: Array<CompanySummaryReport>

  get hasReports () {
    return (
      this.companySummaryReports.length > 0
    )
  }

  // ============================================================================

  reportType = 'BẢNG TỔNG HỢP'
  reportTypes = ['BẢNG TỔNG HỢP']

  get tab () {
    return _.indexOf(this.reportTypes, this.reportType)
  }
  set tab (index) {
    this.reportType = this.reportTypes[index]
  }

  // ============================================================================

  get currentComponent () {
    const mapper: { [index: string]: unknown } = {
      'BẢNG TỔNG HỢP': BaoCaoBangTongHop,
    }
    const component = mapper[this.reportType]
    return component
  }

  get currentReports () {
    const mapper: { [index: string]: unknown } = {
      'BẢNG TỔNG HỢP': this.companySummaryReports,
    }
    const reports = mapper[this.reportType]
    return reports
  }
}
